import React from 'react';

const IntroSection = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-[#5A5046] text-lg mb-4">
              Most frugal living advice is <em>scattered tips</em>.
            </p>
            <p className="text-[#5A5046] text-lg">
              SpendLess is a <em>system</em>.
            </p>
          </div>
          
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C1810] mb-6 leading-tight">
              You don't need to earn more to live better.
            </h2>
            
            <p className="text-[#5A5046] text-lg mb-4 leading-relaxed">
              Most people overspend without realizing it. Convenience habits, autopilot subscriptions, and a food system designed to extract maximum money for minimum nutrition.
            </p>
            
            <p className="text-[#5A5046] text-lg mb-4 leading-relaxed">
              SpendLess gives you a repeatable system to flip that. Audit what you spend. Eliminate what doesn't serve you. Replace expensive habits with better alternatives. Optimize everything else.
            </p>
            
            <p className="text-[#5A5046] text-lg leading-relaxed">
              This isn't about deprivation. It's about designing a life with intention — where every dollar works harder and every system you build makes life easier.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;